class ProfileScreenController {

    constructor() {

        var that = this;
        this.template = Handlebars.compile($("#worldProfileScreen").html());
        this.editProfileTemplate = Handlebars.compile($("#worldEditProfileScreen").html());
        this.changePasswordPopup = Handlebars.compile($("#changePasswordPopUp").html());
        this.profileImage = null;
        this.userId = null;
        this.enabledEmailNotifications = false;
        this.catList = {};

        this.openSubChart();

        $(document).on("click", '.profile-section .edit-my-profile', function () {

            if (world.user_can_edit_profile) {

                const $userAvatar = $(".profile-info-panel .user-avatar");
                const $userName = $(".profile-user-data-panel .user-name");
                const $userSurname = $(".profile-user-data-panel .user-surname");
                const $userAlias = $(".profile-user-data-panel .user-alias");
                const $userEmail = $(".profile-user-data-panel .user-email");
                const $userPhone = $(".profile-user-data-panel .user-phone");

                baseController.stackSimpleContent(that.editProfileTemplate, {
                    userAvatar: $userAvatar.css("background-image").replace('url(','').replace(')',''),
                    userName: $userName.text(),
                    userSurname: $userSurname.text(),
                    userAlias: $userAlias.text(),
                    userEmail: $userEmail.text(),
                    userPhone: $userPhone.text(),
                    world: world,
                    locale: storage.getItem('locale'),
                    enabledEmailNotifications: that.enabledEmailNotifications,
                    externalLogin: storage.getItem("external_login") === 'true',
                }, 'PROFILE');

                $(".edit-profile-section .close-button").on("click.closeStack", function() {
                    baseController.closeStack();
                });

                $(".profile-edit-form :input").on("change", function() {
                    $(".edit-profile-section .action-button.save-changes").removeClass("disabled");
                });

                ga('send', 'pageview', analytics.GA_SCREEN_EDIT_PROFILE);
            }

        });

        $(document).on("click", '#profile-edit-cancel-btn', function () {
            $('#profile-edit').slideUp();
            $('#profile-info').slideDown();
            ga('send', 'pageview', analytics.GA_SCREEN_PROFILE);
        });

        $(document).on("click", '.change-profile-image-button', function () {
            if (world.world_user_icon_mode == 1) {
                $('#profile-input-avatar').trigger('click');
            } else if (world.world_user_icon_mode == 2 || world.world_user_icon_mode == 3) {
                chooseAvatarFullModalController.open(function (url, base64Img) {
                    $('.change-profile-image-button').css('background-image', 'url(' + url + ')');
                    that.profileImage = base64Img;//.match(/,(.*)$/)[1];
                });
            }
            return false;
        });

        $(document).on("change", '#profile-input-avatar', function () {
            var ext = this.files[0]['name'].substring(this.files[0]['name'].lastIndexOf('.') + 1).toLowerCase();

            if (this.files && this.files[0] && (ext == "gif" || ext == "png" || ext == "jpeg" || ext == "jpg")) {
                var reader = new FileReader();
                reader.onload = function (e) {
                    $('.change-profile-image-button').css('background-image', 'url(' + e.target.result + ')');

                    that.profileImage = e.target.result.match(/,(.*)$/)[1];
                }
                reader.readAsDataURL(this.files[0]);
            }
        });

        $(document).on("click", '.edit-profile-section .action-button.save-changes', function () {
            if (!$("#profile-input-alias").val()) {
                notify(Translator.trans('TR_INTRODUCE_TU_ALIAS_E_IMAGEN_DE_USUARIO'), "danger");
                return false;
            }

            let webNotifications = false;
            const email = user.email;

            if ($("#profile-checkbox-notifications").is(':checked')) {
                webNotifications = true;
            }

            var prevLang = storage.getItem("locale");
            storage.setItem("locale", $("#profile-select-language").val());
            navigatorLanguage = $("#profile-select-language").val();

            api.updateProfile(
                world.token,
                that.profileImage,
                $("#profile-input-alias").val(),
                $("#profile-input-name").val(),
                $("#profile-input-surname").val(),
                email,
                $("#profile-input-phone").val(),
                webNotifications,
                $("#profile-input-password").val(),
                $("#current_password").val(),
                navigatorLanguage,
                function () {

                    $("#playerImg").css("background-image", $(".change-profile-image-button").css("background-image"));
                    $(".profile-info-panel .user-avatar").css("background-image", $(".change-profile-image-button").css("background-image"));
                    $(".profile-info-panel .full-name").text($("#profile-input-name").val() + " " + $("#profile-input-surname").val());
                    $(".profile-user-data-panel .user-name").text($("#profile-input-name").val());
                    $(".profile-user-data-panel .user-surname").text($("#profile-input-surname").val());
                    $(".profile-user-data-panel .user-alias").text($("#profile-input-alias").val());
                    // $(".profile-user-data-panel .user-email").text($("#profile-input-email").val());
                    $(".profile-user-data-panel .user-phone").text($("#profile-input-phone").val());

                    if (prevLang != $("#profile-select-language").val()) {
                        api.login(window.blackBox.getAvatar(), window.blackBox.getPhrase());
                    }

                    baseController.closeStack();
                });
        });

        $(document).on("click.openEmailPopup", '.profile-edit-form .profile-input.user-email', function (e) {
            const changeEmailPopup = Handlebars.compile($("#changeEmailPopUp").html());

            popUpController.setPopUp(changeEmailPopup, {
                world: world,
                currentEmail: $(".profile-edit-form .profile-input.user-email input").val()
            });

            popUpController.showPopUp("bottom");

            $(".action-button.discard-changes").on("click.discardChanges", function () {
                popUpController.hidePopUp();
            });

            $(document).off('click.changeEmail').on('click.changeEmail', '.popup-change-email .save-changes', function () {
                const trimEmail = $("#update-email-input").val().trim();
                const passwordInput = $("#current-password-input").val() ?? '';

                if (trimEmail !== '') {
                    if (!isValidEmailAddress(trimEmail)) {
                        notify(Translator.trans('TR_EMAIL_NO_VALIDO'), "danger");
                        return false;
                    }
                }

                if(passwordInput.length <= 0) {
                    notify(Translator.trans('TR_USER_OR_PASSWORD_INCORRECT'), "danger");
                    return false;
                }

                api.updateEmailProfile(
                    world.token,
                    trimEmail,
                    passwordInput,
                    function () {
                        // $(".profile-user-data-panel .user-email").text($("#profile-input-email").val());
                        $(".profile-edit-form .profile-input.user-email > input").val(trimEmail);

                        popUpController.hidePopUp();
                    });
            });
        });

        $(document).on("click.showChangePassPopUp", '.action-button.change-password', function (e) {

            popUpController.setPopUp(that.changePasswordPopup, {
                world: world,
                show_pass_icon: customIcons["LOGIN_EYE_ON_ICON"],
                hide_pass_icon: customIcons["LOGIN_EYE_OFF_ICON"]
            });

            popUpController.showPopUp("bottom");

            $(".action-button.discard-changes").on("click.discardChanges", function() {
                popUpController.hidePopUp();
            });

            tintImage($('#show-password-icon').attr('id'), $('#show-password-icon').attr('data-icon'), world.theme.color_1);
            tintImage($('#hide-password-icon').attr('id'), $('#hide-password-icon').attr('data-icon'), world.theme.color_1);

            const passReg = getPasswordCriteria();
            const passwordInput = $('#password-input');
            const passwordRepeatInput = $('#password-repeat-input');
            const currentPassword = $('#current_password');

            const showPasswordIcon = $('#show-password-icon');
            const hidePasswordIcon = $('#hide-password-icon');
            const showHidePasswordText = $('.show-hide-password-text');
            const correctPasswordIcon = $('.password-input-icon');
            const correctPasswordRepeatIcon = $('.password-repeat-input-icon');
            const saveButton = $('.popup-change-password .action-button.save-changes');
            let hiddenPassword = true;

            // Show/Hide passwords
            $('.show-hide-password-container').off().on("click", function() {

                if (hiddenPassword) {
                    hiddenPassword = false;
                    passwordInput.hideShowPassword(true);
                    passwordRepeatInput.hideShowPassword(true);
                    currentPassword.hideShowPassword(true);
                    showPasswordIcon.addClass('d-none');
                    hidePasswordIcon.removeClass('d-none');
                    showHidePasswordText.text(Translator.trans('TR_OCULTAR_CONTRASENYAS'));
                } else {
                    hiddenPassword = true;
                    passwordInput.hideShowPassword(false);
                    passwordRepeatInput.hideShowPassword(false);
                    currentPassword.hideShowPassword(false);
                    showPasswordIcon.removeClass('d-none');
                    hidePasswordIcon.addClass('d-none');
                    showHidePasswordText.text(Translator.trans('TR_MOSTRAR_CONTRASENYAS'));
                }

            });

            $(document).off('input.changePassword').on('input.changePassword', '#password-input, #password-repeat-input', function() {

                let correctPassword = false;
                let correctRepeatPassword = false;

                if(passwordInput.val().match(passReg)) {
                    correctPasswordIcon.attr("class", "correct-password-icon password-input-icon");
                    correctPassword = true;
                } else {
                    correctPasswordIcon.attr("class", "correct-password-icon password-input-icon d-none");
                    correctPassword = false;
                }

                if (passwordRepeatInput.val().length > 0 && passwordRepeatInput.val() === passwordInput.val()) {
                    correctPasswordRepeatIcon.attr("class", "correct-password-icon password-repeat-input-icon");
                    correctRepeatPassword = true;
                } else {
                    correctPasswordRepeatIcon.attr("class", "correct-password-icon password-repeat-input-icon d-none");
                    correctRepeatPassword = false;
                }

                if(correctPassword && correctRepeatPassword) {
                    saveButton.removeClass('disabled');
                } else {
                    saveButton.addClass('disabled');
                }

                return false

            });

            $(document).off('focusout.changePassword').on('focusout.changePassword', '#password-input, #password-repeat-input', function() {

                let errorMessage = "";

                if (correctPasswordIcon.hasClass('d-none')) {
                    errorMessage = Translator.trans('TR_LA_CONTRASENYA_NO_CUMPLE');
                } else if (correctPasswordRepeatIcon.hasClass('d-none')) {
                    errorMessage = Translator.trans('TR_LAS_CONTRASENYAS_NO_COINCIDEN');
                }

                if (correctPasswordIcon.hasClass('d-none') || correctPasswordRepeatIcon.hasClass('d-none') && passwordRepeatInput.val().length > 0) {
                    $.notify({message: errorMessage}, {
                        type: 'danger',
                        delay: 3000,
                        placement: {
                            from: "top",
                            align: "center"
                        },
                        z_index: 1050
                    });
                }

            });

            $(document).off('click.confirmPasswordChange').one('click.confirmPasswordChange', '.popup-change-password .action-button.save-changes', function () {
                api.updateUserPassword(
                    world.token,
                    passwordInput.val(),
                    $("#current_password").val(),
                    function () {
                        popUpController.hidePopUp();
                        swal({
                            title: "",
                            text: Translator.trans('TR_CONTRASENYA_ACTUALIZADA'),
                            confirmButtonText: Translator.trans('TR_ACEPTAR'),
                            closeOnConfirm: true,
                            html: true
                        });
                    });
            });

        });

        $(window).scroll(function () {
            $('#profile-my-knowledge iframe').css('pointer-events', 'none');
            clearTimeout($.data(this, 'scrollTimer'));
            $.data(this, 'scrollTimer', setTimeout(function () {
                $('#profile-my-knowledge iframe').css('pointer-events', 'auto');
            }, 250));
        });
    };


    drawKnowdelegeList(response) {
        let that = this;

        // Convert progress
        for (let i = 0; i < response.result.categories_user.length; i++) {
            let category = response.result.categories_user[i].category;
            category.progressPercent = Math.floor(parseFloat(category.progress)*100);
            category.hasSubcategories = category.subcategories.length > 0;

            if(category.hasSubcategories)
                that.catList[category.id] = category;
        }

        chartSocket.on(SocketEvents.KNOWLEDGE_LIST_RESPONSE(), function (socketRes) {
            if(socketRes.success && $(".stackable").last().hasClass('profileScreen')){
                $("#iframeProfile").hide();
                that.loadSubcategoryInfo(that.catList, socketRes.cat_id);
            }
        });

        if($('#kwnodelegeListProfile').length) {
            var template = Handlebars.compile($("#knowdelegeFragment").html());
            $('#knowdelegeSpinner,#knowdelegeTitle').remove();

            $("#kwnodelegeListProfile").html(template(response.result.categories_user));

            $('#kwnodelegeListProfile').find('.my-knowledge-list-element-progress').each(function (i, elem) {
                var progress = parseInt($(elem).attr('data-progress'));
                createProgressChart($(elem), progress);
            });

            if (!detectmob()) {
                console.trace('not detectmob....');
                // $("#kwnodelegeListProfile").niceScroll();
            }

            let height = 40;

            if ($(window).width() <= 420) {
                height = 30;
            }

            $('.my-knowledge-list-element-name').dotdotdot({
                height: height,
                watch: 'true',
                truncate: 'letter'
            });

        }
    }

    openSubChart() {
        const that = this;

        $(document).on('click.subcategoriesChartProfile', '#kwnodelegeListProfile .element-with-subcategories', function() {
            that.loadSubcategoryInfo(that.catList, $(this).data('category'));
        });
    }

    draw(result, isCurrentUser, isChat=false, chartToken=false) {
        var title = (isCurrentUser) ? 'TR_PERFIL' : 'TR_FICHA_DE_USUARIO';

        if(!isChat) {
            baseController.resetStackableOrder();
        }

        var numChallengesLost = result.user.num_challenges_lost;
        var numChallengesEven = result.user.num_challenges_even;
        var numChallengesWon = result.user.num_challenges_won;
        var numChallenges = numChallengesLost + numChallengesEven + numChallengesWon;
        var colors = ['#F5222D', '#00B3E6', '#6CC33C'];

        if (numChallenges == 0) {
            numChallengesLost = 1;
            numChallengesEven = 0;
            numChallengesWon = 0;
            colors = ['rgba(255,255,225,0.3)', 'rgba(255,255,225,0.3)', 'rgba(255,255,225,0.3)'];
        }

        result.user.num_challenges = numChallenges;
        result.user.principal_subsegment = _.find(result.groups, function(groupItem) {return groupItem.group.profile})

        var rankingIcon = customIcons["RANKING_TOP_BEST"];
        var challengeIcon = customIcons["RANKING_TOP_CHALLENGE"];
        var wiseIcon = customIcons["RANKING_TOP_WISE"];
        var fastIcon = customIcons["RANKING_TOP_FASTEST"];
        var accuracyIcon = customIcons["RANKING_TOP_ACCURACY"];

        _.forEach(result.rankings, function (ranking) {
            ranking.ranking.customUnit = sprintf(ranking.ranking.customUnit, ranking.ranking.points);
        });

        var context = {
            world: world,
            user: user,
            result: result,
            isCurrentUser: isCurrentUser,
            locale: storage.getItem('locale'),
            login_username: window.blackBox.getAvatar(),
            socket_id: chartSocket.id,
            rankingIcon: rankingIcon,
            challengeIcon: challengeIcon,
            wiseIcon: wiseIcon,
            fastIcon: fastIcon,
            accuracyIcon: accuracyIcon,
            token: chartToken,
            isChat: isChat,
            chatTabEnabled: $('.chatTab').length > 0,
        };

        if(isChat){
            $("#chat-messages-profile-area").html(this.template(context));
        } else {
            baseController.stackSimpleContent(this.template, context, 'PROFILE');
        }

        $('#profileImg').css('background-image', 'url(' + result.user.icon + ')');
        $('.change-profile-image-button').css('background-image', 'url(' + result.user.icon + ')');
        $('#profileProgressBar').css('width', result.user.level.progress * 100 + '%');

        let profileAliasNameHeight = 65;

        if ($(window).width() <= 420) {
            profileAliasNameHeight = 50;
        }

        if ($(window).width() >= 1920) {
            profileAliasNameHeight = 80;
        }

        $('#profile-alias, #profile-name').dotdotdot({
            wrap: 'letter',
            watch: true,
            height: profileAliasNameHeight,
        });

        var levelIcon = $('#profile-level-icon');
        levelIcon.attr('data-percent', Math.floor(levelIcon.attr('data-percent') * 100));
        levelIcon.attr('data-part', Math.floor(levelIcon.attr('data-part') * 100));
        levelIcon.attr('data-dimension', '105');
        levelIcon.circliful();

        $('#profile-challenges-chart').highcharts({
            chart: {
                backgroundColor: 'rgba(255,255,225,0.0)'
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            },
            title: {
                text: '',
                align: 'center',
                floating: true
            },
            tooltip: {
                enabled: false
            },
            plotOptions: {
                pie: {
                    dataLabels: {
                        enabled: false
                    },
                    borderColor: null,
                    center: ['50%', '50%'],
                    states: {
                        hover: {
                            enabled: false
                        }
                    }
                }
            },
            series: [{
                type: 'pie',
                innerSize: '85%',
                data: [
                    ['', numChallengesLost],
                    ['', numChallengesEven],
                    ['', numChallengesWon]
                ],
                colors: colors
            }]
        });

        this.userId = result.user.id;
        this.enabledEmailNotifications = result.user.email_notifications;

        api.getCategoriesInfo(this.drawKnowdelegeList.bind(this));

        let profileGroupHeight = 40;

        if ($(window).width() <= 420) {
            profileGroupHeight = 30;
        }

        $('.profile-group-name, .profile-group-value').each(function () {
            $(this).dotdotdot({
                wrap: 'letter',
                watch: true,
                height: profileGroupHeight
            });
        });

        ga('send', 'pageview', analytics.GA_SCREEN_PROFILE);

        $(".profile-section .close-button").on("click.closeStack", function() {

            const documentationHeaderCloseButton = $("#documentation-header-close-btn");

            if (documentationHeaderCloseButton.length > 0) {
                documentationHeaderCloseButton.show();
            }

            baseController.closeStack();

        });

        $(".profile-section .action-button.follow-user").on("click.followUser", function() {

            const userWorldId = $(this).data("user");

            api.followUser(userWorldId, function(response) {
                if (api.checkisValidResult(response)) {
                    result.followers += 1;
                    $(".action-button.follow-user").hide();
                    $(".action-button.unfollow-user").show();
                    $(".total-followers-box > .text").text(sprintf(Translator.trans("TR_X_LE_SIGUEN"), result.followers));
                    $(".friend-item[data-user=" + userWorldId + "] .friend-following").show();
                }
            }, false);
        });

        $(".profile-section .action-button.unfollow-user").on("click.unfollowUser", function() {

            const userWorldId = $(this).data("user");

            api.unfollowUser(userWorldId, function(response) {
                if (api.checkisValidResult(response)) {
                    result.followers -= 1;
                    $(".action-button.unfollow-user").hide();
                    $(".action-button.follow-user").show();
                    $(".total-followers-box > .text").text(sprintf(Translator.trans("TR_X_LE_SIGUEN"), result.followers));
                    $(".friend-item[data-user=" + userWorldId + "] .friend-following").hide();
                }
            }, false);
        });

        $(".send-email-button").on("click.sendEmail", function() {
            window.open('mailto:' + $(this).data("email"));
        });

        $(".call-phone-button").on("click.sendCall", function() {
            window.open('tel:' + $(this).data("phone"));
        });

        $(".challenge-button").on("click.sendChallenge", function() {
            worldHomeController.onClickUserChallenge($(this).data("user"));
        });

        $(".chat-button").on("click.sendMessage", function() {

            function _filterRoomCondition(room) {
                return room.user && (room.user.user_world_id == userWorldId)
            }

            function _drawChatRoom() {

                if (world.profile_customization.show_opponent_profile && userWorldId) {

                    roomToDraw = chatScreenController.individualRooms.rooms.filter(_filterRoomCondition)[0];

                    if (!roomToDraw) {
                        roomToDraw = chatScreenController.chat.getNewEmptyRoom(user, chatScreenController.INDIVIDUAL_ROOM);
                    }

                    chatScreenController.drawIndividualChat(roomToDraw);

                }

            }

            let roomToDraw = null;
            let user = null;
            const userWorldId = $(this).data("user");

            api.getUsersDirectory(userWorldId, function(response) {
                user = response.result.users[0];
                _drawChatRoom();
            });

        });

    };

    loadSubcategoryInfo(catList, catId){
        let subCatList = [];

        // Convert progress
        for (let i = 0; i < catList[catId]['subcategories'].length; i++) {
            let category = catList[catId]['subcategories'][i];
            category.progressPercent = Math.floor(parseFloat(category.progress)*100);
            subCatList.push({category: category});
        }

        if(subCatList.length > 10) {
            var template = Handlebars.compile($("#knowdelegeFragment").html());
            $('#knowdelegeSpinner,#knowdelegeTitle').remove();

            $("#kwnodelegeListProfile").hide();

            $("#kwnodelegeListProfileSubcategory").show();

            $("#kwnodelegeListProfileSubcategory").html(template(subCatList));

            $('#kwnodelegeListProfileSubcategory').find('.my-knowledge-list-element-progress').each(function (i, elem) {
                var progress = parseInt($(elem).attr('data-progress'));
                createProgressChart($(elem), progress);
            });

            if (!detectmob()) {
                // $("#kwnodelegeListProfileSubcategory").niceScroll();
                console.trace('not detectmob');
            }

            $(".profile-box-title .back-btn").show();

            $(".profile-box-title .back-btn").one('click', function (){
                $('#kwnodelegeListProfileSubcategory').empty();
                $("#kwnodelegeListProfileSubcategory").hide();
                $(this).hide();

                $("#iframeProfile").show();
                $("#kwnodelegeListProfile").show();
            });
        } else {
            $("#kwnodelegeListProfile").hide();

            $(".profile-box-title .back-btn").show();

            $(".profile-box-title .back-btn").one('click', function (){
                $('#iframeProfileSubCat').remove();
                $(this).hide();
                $("#kwnodelegeListProfile").show();
            });

            api.getChartToken(function (responseToken) {
                $("#profile-my-knowledge").append('<iframe id="iframeProfileSubCat" src=\'/chart?isWebsite=true&chart_type=full&world_token=' + world.token +
                    '&socket_id=' + chartSocket.id + '&socket_user_world_id=' + user.user_world_id + '&parent=' + catId + '&chartToken=' + responseToken.token + '\' frameborder="0"></iframe>');
            });
        }
    }
}